"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const processSteps = [{
  id: 1,
  title: "İlk Muayene ve Planlama",
  description: "Detaylı klinik muayene ve 3D radyolojik görüntüleme ile çene yapınız incelenerek size en uygun tedavi planı titizlikle oluşturulur."
}, {
  id: 2,
  title: "İmplant Yerleşimi",
  description: "Lokal anestezi altında, uzman hekimlerimiz tarafından titanyum implant vidaları çene kemiğine hassas bir cerrahi operasyonla yerleştirilir."
}, {
  id: 3,
  title: "Osseointegrasyon Süreci",
  description: "İmplantın kemik dokusuyla biyolojik olarak bütünleşmesi için beklenen bu dönemde, estetiğinizi korumak adına geçici dişleriniz uygulanır."
}, {
  id: 4,
  title: "Final Protez Uygulaması",
  description: "İyileşme tamamlandığında, doğal diş formunda ve renginde hazırlanan porselen veya zirkonyum dişleriniz kalıcı olarak implant üzerine takılır."
}];
function ProcessStep({
  step,
  index
}: {
  step: typeof processSteps[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const isOdd = index % 2 === 0;
  return <div data-section-id="138293" ref={ref} data-index={index} className={cn("relative w-full mb-12 md:mb-24 last:mb-0 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
      {}
      <div className="absolute left-6 md:left-1/2 top-0 w-12 h-12 rounded-full bg-transparent text-primary/10 flex items-center justify-center font-bold text-7xl md:text-[120px] z-10 -translate-x-1/2 shadow-none font-serif select-none pointer-events-none">
        {step.id}
      </div>

      {}
      <div className={cn("w-full pl-20 md:pl-0 md:w-1/2 pt-1.5", isOdd ? "md:pr-16 md:text-right md:ml-0" : "md:pl-16 md:ml-auto")}>
        <h3 className="text-xl md:text-[32px] font-bold text-primary mb-3 font-serif tracking-tight">
          {step.title}
        </h3>
        <p className="text-foreground/70 font-sans leading-[1.6] text-base md:text-lg">
          {step.description}
        </p>
      </div>
    </div>;
}
export default function HowItWorks() {
  return <section id="implant-süreci-ve-adımları" className="bg-background py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-foreground tracking-tighter">
            İmplant Tedavi Süreci
          </h2>
        </div>

        {}
        <div className="relative max-w-5xl mx-auto">
          {}
          <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-[2px] bg-primary -translate-x-1/2 opacity-10 rounded-full" />

          {}
          <div className="relative z-10">
            {processSteps.map((step, index) => <ProcessStep key={step.id} step={step} index={index} />)}
          </div>
        </div>

        {}
        <div className="mt-16 md:mt-24 text-center">
          <Link to="/ContactPage">
            
          </Link>
        </div>
      </div>
    </section>;
}